/**
 * Format a number with appropiate currency
 * This function is partially applied
 *
 * Usage:
 * formatCurrency('EUR', 'es-ES')(100)
 */
export const formatCurrency = (
    currency = 'USD',
    locale = navigator.language,
    options = { minimumFractionDigits: 2 },
) => {
    const currencyFormatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        ...options,
    });

    return (number) => currencyFormatter.format(number);
};

export const getCurrencySymbol = (currencyCode, locale = 'en-US') => {
    const formattedCurrencyArray = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
    }).formatToParts();
    const symbol = formattedCurrencyArray.find((part) => part.type === 'currency');
    return symbol.value;
};

export const convertCurrencyStringToNumber = (currencyString) => {
    const currencyNumber = Number(currencyString.replace(/[^0-9.-]+/g, ''));

    return currencyNumber;
};
